module.exports = __webpack_public_path__ + "static/assets/permission_microphone.png";